import json from './sprite.js';

export default {
    handle: 'ENG_SPS1-Basketball',
    label: 'en_SPS1-Basketball_225002182',
    json,
};
